import pollImportStatus from './poll_import_status'
import importStatusWizardPage from './import_status_wizard_page'
import importState from './import_state'

export default angular
  .module('adminPanel.imports', [])
  .factory('importState', importState)
  .component('pollImportStatus', pollImportStatus)
  .component('importStatusWizardPage', importStatusWizardPage).name
